import React from "react";

function Icon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 37.299 46.65" className={className}>
      <path
        d="M20.224,34.515c3.626,0,5.608-2.565,5.608-6.18H14.6C14.6,31.95,16.586,34.515,20.224,34.515Z"
        transform="translate(-1.598 12.134)"
      />
      <path
        d="M43.588,38.478c-1.8-2.367-5.328-3.754-5.328-14.353,0-10.878-4.8-15.251-9.281-16.3-.42-.1-.723-.245-.723-.688V6.8a2.845,2.845,0,1,0-5.69,0v.338c0,.431-.3.583-.723.688-4.489,1.061-9.281,5.422-9.281,16.3,0,10.6-3.533,11.974-5.328,14.353a2.314,2.314,0,0,0,1.854,3.708H41.745A2.315,2.315,0,0,0,43.588,38.478Z"
        transform="translate(-6.761 -3.93)"
      />
    </svg>
  );
}

export { Icon };
